import * as React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_MCE_API_KEY } from '../../../core/constants';

interface ConfirmationMessageFormProps {
  saveCallback: (callbackValue: string) => void;
  message: string;
}

// set editor style to match waiver display style in order-frontend/src/components/Confirmation/Confirmation.scss
// Since confirmation is also sent as email, it uses more of the default paragraph styles.
const EDITOR_STYLE =
  'ol ol { list-style-type: lower-alpha; } ' +
  'ol ol ol { list-style-type: lower-roman; } ' +
  'ol ol ol ol { list-style-type: lower-alpha; } ' +
  'ol, ul { padding-left: 2rem; }';

const ConfirmationMessageForm = ({
  saveCallback,
  message
}: ConfirmationMessageFormProps) => {
  const [confirmationMessageContent, setConfirmationMessageContent] = React.useState(message || '');

  const saveAndHoist = (value: string) => {
    setConfirmationMessageContent(value);
    saveCallback(value);
  }

  return (
    <div className="Grid-cell u-xs-padBottomXl">
      <Editor
        apiKey={TINY_MCE_API_KEY}
        onEditorChange={saveAndHoist}
        value={confirmationMessageContent}
        init={{
          menubar: false,
          resize: false,
          preview_styles: false,
          relative_urls: false,
          convert_urls: false,
          height: '700',
          statusbar: false,
          plugins: 'bullist link lists textpattern',
          contextmenu: 'list link',
          toolbar_mode: 'wrap',
          toolbar:
            'undo redo | formatselect | bold italic underline forecolor backcolor | link unlink | alignleft aligncenter alignright alignjustify | numlist bullist',
          placeholder: 'e.g. Please send documents to....',
          content_style: EDITOR_STYLE,
        }}
      />
    </div>
  )
};

export default ConfirmationMessageForm;
